import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "file-clear",
  "use": "file-clear-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"file-clear\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#6644EA\" fill-rule=\"nonzero\" /><g stroke=\"#FFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M16.833 8H11c-.92 0-1.667.716-1.667 1.6v12.8c0 .884.746 1.6 1.667 1.6h10c.92 0 1.666-.716 1.666-1.6v-8.8L16.833 8z\" /><path d=\"M16.833 8v5.6h5.833\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol